/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const messages = {
  auth: {
    empty: "You can't leave this empty!",
    invalid_email: "Enter a valid email address!",
    error_login: "Error in continue to login.",
    error_login_auth:
      "Incorrect username or password.  Please try again or reset your password.",
    forgot_response: "You will get an email with reset password link soon",
    forgot_view_response:
      "Check your inbox. An email is on its way, if a user account exists with the email address provided.",
    reset_pass_empty: "Enter your new password.",
    reset_confpass_empty: "Enter your confirm password.",
    reset_confpass_wrong: "Sorry!! Confirm password is wrong.",
    error_pass:
      "Password is too short. Please ensure password is at least 8 characters.",
  },
  email_already_exist: "Email with given user already exist!",
  signup_error: "User with the given email already exist!",
  general_api_error: "Something went wrong. Please try again later!!!",
  too_many_requests:
    "There have been several failed attempts to sign in from this account or IP address. Please wait a while and try again later.",
  admin_reject:
    "The email provided belongs to a disabled user account. Please contact your account admin or support@datazoom.io for assistance.",
  invalid_email_error:
    "Accounts can only be created using an enterprise email address. Please contact support@datazoom.io if you need to create an account with a public email domain.",
  collector: {
    collector_name_empty: "Please enter name for this Collector",
    collector_player_empty: "Please select video player",
    collector_search_msg: "No Configuration match your search criteria",
    collector_empty_company: "Please select the company of this Collector",
    empty_field: "You can't leave this empty!",
  },
  connector: {
    connector_search_msg: "No Connector match your search criteria",
    connector_empty_title: "Please enter a name for this Connector",
    connector_empty_company: "Please select the company of this Connector",
  },
  datapipe: {
    datapipe_search_msg: "No Datapipe match your search criteria",
    datapipe_connector_empty: "Please select at least one connector",
    datapipe_collector_empty: "Please select at least one collector",
    datapipe_empty_title:
      "Please enter a name for this Data Pipe before saving.",
    datapipe_empty_company: "Please select the company of this Data Pipe",
    datapipe_no_company:
      "Please select a company to proceed with Data Pipe creation",
    datapipe_incompatible_error:
      "Your data pipe has incompatible Collectors and Connectors. Please remove one of the affected items to resolve the problem.",
    datapipe_collector_config_empty:
      "Please select any one datapoint in the collector",
  },
  user: {
    user_search_msg: "No User match your search criteria",
    name_empty_error: "Name cannot be empty.",
    email_empty_error: "Email cannot be empty.",
    email_invalid_error: "Enter a valid email address.",
    company_empty_error: "Select your company.",
    role_empty_error: "Select your role.",
  },
  company: {
    company_search_msg: "No Company match your search criteria",
  },
  admin_settings: {
    confirm_activate_message: "Are you sure you want to activate this item?",
    confirm_deactivate_message:
      "Are you sure you want to deactivate this item?",
    confirm_delete_message: "Are you sure you want to delete this item?",
  },
  api_keys: {
    no_api_keys: "Currently no API Key Available.",
    success_msg: "API key has been created successfully",
  },
  rate: {
    rate_name_empty: "Please enter display name for this Rate",
    rate_type_empty: "Please select rate type ",
    rate_startDate_empty: "Please enter a valid start date",
    rate_endDate_empty: "Please enter a valid end date",
    rate_endDate_invalid: "Invalid end date",
    rate_collecton_rate_empty: "Please enter collection rate",
    rate_computation_rate_empty: "Please enter computation rate",
    rate_connecton_rate_empty: "Please enter connection rate",
    rate_search_msg: "No rate match your search criteria",
    rate_connection_not_zero: "Connection Rate must be greater than 0",
    rate_collection_not_zero: "Collection Rate must be greater than 0",
    rate_customerCode_error: "Select your company",
  },
  credit: {
    credit_empty: "Please enter credit amount",
    credit_format: "Please enter a valid credit",
    credit_zero: "Please enter an adjustable value",
  },
  trial_period: {
    user: {
      less_than_50_msg:
        "Enjoy your free trial! Please notify your company admin.",
      less_than_80_msg:
        "You’re doing great with your free trial! Please notify your company admin.",
      less_than_100_msg:
        "You’ve almost used all of your free trial data! Please notify your company admin.",
    },
    admin: {
      less_than_50_msg: "Enjoy your free trial! Click here to continue Zooming",
      less_than_80_msg:
        "You’re doing great with your free trial! Click here to keep your data flowing",
      less_than_100_msg:
        "You’ve almost used all of your free trial data! Enter your payment info to keep your account active.",
    },
  },
  could_not_send_resent_link: "Can't send reset password link.",
  could_not_send_reset_password_link:
    "Invalid email or user. Can't send reset password link.",
  invalid_reset_password_message:
    "Invalid email or user. Unable to send password reset link.",
};
